<template>
  <b-modal
    id="company-modal"
    :title="
      readonly
        ? 'عرض بيانات الشركة'
        : form.id
        ? 'تحديث بيانات الشركة'
        : 'أضافة شركة'
    "
    shadow
    hide-footer
    :no-close-on-backdrop="true"
    @show="initialPosition"
    size="lg"
    body-class="p-5"
  >
    <VForm v-slot="{ onValidate }">
      <div class="upload-example">
        <div v-if="form.id && !coverImageChanged">
          <img :src="form.cover" alt="Cover" class="uploaded-image cover" />
          <div style="text-align: center">
            <span class="button" @click="showCoverCropper"
              >رفع صورة غلاف جديدة</span
            >
          </div>
        </div>
        <Cropper
          v-else
          ref="coverCropper"
          class="upload-example-cropper"
          :src="coverImage"
          :stencil-component="$options.components.RectangularStencil"
          :resizable="false"
          :aspect-ratio="2.5"
        />
        <div style="margin-bottom: 20px"></div>
        <div class="button-wrapper" v-if="!form.id || coverImageChanged">
          <span class="button" @click="$refs.coverFile.click()">
            <input
              type="file"
              ref="coverFile"
              @change="uploadCoverImage($event)"
              accept="image/png,image/jpg,image/jpeg,image/gif"
            />
            صورة الغلاف
          </span>
        </div>
      </div>
      <div style="margin-bottom: 20px"></div>
      <div class="upload-example">
        <div v-if="form.id && !logoImageChanged">
          <img :src="form.logo" alt="Logo" class="uploaded-image logo" />
        </div>
        <div v-if="form.id && !logoImageChanged">
          <span class="button" @click="showLogoCropper"
            >رفع صورة شعار جديدة</span
          >
        </div>
        <Cropper
          v-else
          ref="cropper"
          class="upload-example-cropper"
          :src="logoImage"
          :stencil-component="$options.components.Stencil"
        />
        <div style="margin-bottom: 20px"></div>
        <div class="button-wrapper" v-if="!form.id || logoImageChanged">
          <span class="button" @click="$refs.file.click()">
            <input
              type="file"
              ref="file"
              @change="uploadLogoImage($event)"
              accept="image/png,image/jpg,image/jpeg,image/gif"
            />
            صورة الشعار
          </span>
        </div>
        <div style="margin-bottom: 20px"></div>
      </div>
      <b-row>
        <b-col>
          <VTextField
            v-model="form.name"
            label="أسم الشركة"
            rules="required"
          ></VTextField>
        </b-col>
        <b-col>
          <VTextField
            v-model="form.phone"
            label="رقم الهاتف"
            :rules="form.id ? 'required' : 'required|numeric'"
          ></VTextField>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <VTextField
            v-model="form.email"
            label="البريد الألكتروني"
            rules="required"
          ></VTextField>
        </b-col>
        <b-col>
          <VTextField
            v-model="form.website"
            label="الموقع الألكتروني"
            rules="required"
          ></VTextField>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <VTextField
            v-model="form.address"
            label="العنوان"
            rules="required"
          ></VTextField>
        </b-col>
      </b-row>
      <VTextArea
        v-model="form.about"
        label="عن الشركة"
        rules="required"
      ></VTextArea>
      <div v-if="addLocation" class="my-3 h-100" style="display: contents">
        <b-row class="align-items-center">
          <b-col>
            <VTextField
              v-model="form.lat"
              label="خطوط العرض"
              :readonly="readonly"
            ></VTextField>
          </b-col>
          <b-col>
            <VTextField
              v-model="form.lng"
              label="خطوط الطول"
              rules="required"
              :readonly="readonly"
            ></VTextField>
          </b-col>
        </b-row>
        <span>أو تحديد الموقع على الخريطة</span>
        <gmap-map
          :zoom="14"
          :center="{ lat: parseFloat(form.lat), lng: parseFloat(form.lng) }"
          style="width: 100%; height: 400px"
        >
          <gmap-marker
            :position="{ lat: parseFloat(form.lat), lng: parseFloat(form.lng) }"
            :clickable="true"
            :draggable="true"
            :icon="markerOptions"
            @dragend="setLocation"
          ></gmap-marker>
        </gmap-map>
      </div>
      <b-row class="my-3" v-if="!readonly">
        <b-col>
          <b-button
            :variant="form.id ? 'success' : 'info'"
            block
            @click="
              onValidate(() => {
                cropLogoImage();
                cropCoverImage();
                action();
              })
            "
            >{{ form.id ? "تحديث" : "أضافة" }}</b-button
          >
        </b-col>
        <b-col>
          <b-button
            variant="outline-info"
            block
            @click="$bvModal.hide('company-modal')"
            >الغاء</b-button
          >
        </b-col>
      </b-row>
    </VForm>
  </b-modal>
</template>

<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import Stencil from "./../../../Admin/Banks/components/Stencil.vue";
import RectangularStencil from "./../../../Admin/Banks/components/RectangularStencil.vue";
import { successAlert, errorAlert } from "@/utils/helper";

export default {
  props: { readonly: Boolean },
  data() {
    return {
      addLocation: true,
      markerOptions: {
        url: require("../../../../assets/marker.png"),
        size: { width: 30, height: 60, f: "px", b: "px" },
        scaledSize: { width: 25, height: 45, f: "px", b: "px" },
      },
      logoImage: null, // Initialize as null
      coverImage: null, // Initialize as null
      logoImageChanged: false,
      coverImageChanged: false,
    };
  },

  components: {
    Cropper,
    Stencil,
    RectangularStencil,
  },
  computed: {
    form: {
      get() {
        return this.$store.state.company.companyInfo.form;
      },
      set(value) {
        this.$store.commit("company/companyInfo/SET_COMPANY_INFO", value);
      },
    },
  },
  methods: {
    action() {
      if (!this.addLocation) {
        this.form.lat = 0;
        this.form.lng = 0;
      }

      const promises = [];

      if (this.$refs.cropper) {
        const logoResult = this.$refs.cropper.getResult();
        if (logoResult) {
          if (!logoResult.canvas) {
            errorAlert("الرجاء تأكد من رفع صورة الشعار");
          }
          promises.push(
            new Promise((resolve) => {
              logoResult.canvas.toBlob((blob) => {
                this.form.logo = blob;
                resolve();
              }, "image/png");
            })
          );
        } else if (this.form.id && !this.logoImageChanged) {
          this.form.logo = this.form.logoUrl;
        } else {
          this.form.logo = null;
        }
      }

      if (this.$refs.coverCropper) {
        const coverResult = this.$refs.coverCropper.getResult();
        if (coverResult) {
          if (!coverResult.canvas) {
            errorAlert("الرجاء تأكد من رفع صورة الغلاف");
          }
          promises.push(
            new Promise((resolve) => {
              coverResult.canvas.toBlob((blob) => {
                this.form.cover = blob;
                resolve();
              });
            })
          );
        } else if (this.form.id && !this.coverImageChanged) {
          this.form.cover = this.form.coverUrl;
        } else {
          this.form.cover = null;
        }
      }

      Promise.all(promises).then(() => {
        this.$store
          .dispatch(`company/companyInfo/update`)
          .then(() => {
            this.logoImage = null; // Reset to null
            this.coverImage = null; // Reset to null
            this.logoImageChanged = false; // Reset to false
            this.coverImageChanged = false; // Reset to false
            successAlert();
            this.$bvModal.hide("company-modal");
          })
          .catch((error) =>
            errorAlert(
              error.response ? error.response.data.message : "حدثت مشكله"
            )
          );
      });
    },
    setLocation(data) {
      this.form.lat = data.latLng.lat();
      this.form.lng = data.latLng.lng();
    },
    initialPosition() {
      if (this.form.id) {
        this.form.lat = parseFloat(this.form.lat);
        this.form.lng = parseFloat(this.form.lng);
      } else {
        this.form.lat = 33.312805;
        this.form.lng = 44.361488;
      }
    },
    cropLogoImage() {
      if (this.$refs.cropper) {
        const result = this.$refs.cropper.getResult();
        if (result && result.canvas) {
          result.canvas.toBlob((blob) => {
            if (
              blob.type === "image/png" ||
              blob.type === "image/jpeg" ||
              blob.type === "image/jpg" ||
              blob.type === "image/gif"
            ) {
              this.form.logo = blob; // Store the cropped logo as a binary file
            } else {
              errorAlert("الصورة يجب ان تكون ب امتداد png,jpg,jpeg,gif");
            }
          }, "image/png"); // Default to PNG if no type is specified
        } else {
          this.form.logo = this.logoImage; // Use the original value if no cropping is done
        }
      }
    },

    cropCoverImage() {
      if (this.$refs.coverCropper) {
        const result = this.$refs.coverCropper.getResult();
        if (result && result.canvas) {
          result.canvas.toBlob((blob) => {
            if (
              blob.type === "image/png" ||
              blob.type === "image/jpeg" ||
              blob.type === "image/jpg" ||
              blob.type === "image/gif"
            ) {
              this.form.cover = blob; // Store the cropped cover as a binary file
            } else {
              errorAlert("الصورة يجب ان تكون ب امتداد png,jpg,jpeg,gif");
            }
          }, "image/png"); // Default to PNG if no type is specified
        } else {
          this.form.cover = this.coverImage; // Use the original value if no cropping is done
        }
      }
    },
    uploadLogoImage(event) {
      this.logoImageChanged = true; // Mark logo as changed
      var input = event.target;
      if (input.files && input.files[0]) {
        const file = input.files[0];
        const allowedExtensions = [
          "image/png",
          "image/jpg",
          "image/jpeg",
          "image/gif",
        ];

        if (!allowedExtensions.includes(file.type)) {
          errorAlert("الصورة يجب ان تكون ب امتداد png,jpg,jpeg,gif");
          return;
        }

        var reader = new FileReader();
        reader.onload = (e) => {
          this.logoImage = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    uploadCoverImage(event) {
      this.coverImageChanged = true; // Mark cover as changed
      var input = event.target;
      if (input.files && input.files[0]) {
        const file = input.files[0];
        const allowedExtensions = [
          "image/png",
          "image/jpg",
          "image/jpeg",
          "image/gif",
        ];

        if (!allowedExtensions.includes(file.type)) {
          errorAlert("الصورة يجب ان تكون ب امتداد png,jpg,jpeg,gif");
          return;
        }

        var reader = new FileReader();
        reader.onload = (e) => {
          this.coverImage = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    showLogoCropper() {
      this.logoImageChanged = true;
    },
    showCoverCropper() {
      this.coverImageChanged = true;
    },
  },
};
</script>

<style>
.upload-example-cropper {
  border: solid 1px #eee;
  min-height: 150px; /* Reduced height */
  width: 80%; /* Adjusted width */
  margin: 0 auto; /* Center the cropper */
}

.button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 17px;
}

.button {
  color: white;
  font-size: 16px;
  padding: 10px 20px;
  background: #3fb37f;
  cursor: pointer;
  font-family: Open Sans, Arial;
  margin: 0 10px;
}

.button:hover {
  background: #38d890;
}

.button input {
  display: none;
}

.uploaded-image {
  max-width: 100%;
  height: auto;
  margin-bottom: 10px;
}

/* Make the cover image rectangular */
.uploaded-image.cover {
  width: 100%;
  height: 300px;
  border-radius: 0; /* No border radius for rectangular shape */
}

/* Make the logo image circular */
.uploaded-image.logo {
  width: 100px; /* Set a fixed width for the circular logo */
  height: 100px; /* Set a fixed height for the circular logo */
  border-radius: 50%; /* Fully rounded for circular shape */
  object-fit: cover; /* Ensure the image fits within the circular frame */
}

.upload-example {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
